import React from 'react'
import { ExecuteOperationOnPipe, Model, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import Smartview from 'widgets/smartviews/Smartview'
import Fieldset from 'layouts/form/Fieldset'
import * as Fields from 'support/fields'
import ViewShiftSmartview from 'widgets/smartviews/shifts/ViewShiftSmartview'
import { CallbackOnPipe, Pipeline } from '@morningtrain/react-helpers'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import PropTypes from 'prop-types'
import moment from 'moment'
import * as Filters from 'support/filters'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import useActiveShift from 'support/hooks/use-active-shift'
import { Translation } from '@morningtrain/react-translations'
import Button from 'ui/buttons/Button'
import {Env} from "@morningtrain/helpers";

function CreateShiftSmartview (props) {
  const { scheduleId, weekDay } = props

  const date = moment(props.date)
  const [activeShift, setActiveShift] = useActiveShift()
  const hasClosingType = Env.get('globals.has_closing_type');

  console.log(hasClosingType)
  return (
    <Smartview header={<Translation name='actions.new_shift' />}>
      <div className='mb-6 text-lg font-medium'>
        {date.format('dddd - D MMMM')}
      </div>
      <Model resourceName='shifts.schedule_slot' submittable>
        <Fieldset cols={1}>
          <Fields.Hidden name='schedule_id' defaultValue={scheduleId} />
          <Fields.Hidden name='day' defaultValue={weekDay} />
          <Fieldset cols={2}>
            <Fields.Time fromName='start_at' name='start_time' label='Fra' />
            <Fields.Time fromName='end_at' name='end_time' label='Til' />
          </Fieldset>
          {
            hasClosingType === 1 ?
              <Fields.Select
                name='closing_type' enum='closing_type' placeholder='Ingen'
                label='Lukketype'
              /> : false
          }

          <Fields.Input name='note' label={<Translation name='fields.shift_comment.label' />} />
          <Fields.AvailableScheduleUsers>
            <Filters.StaticFilter name='date' value={props.date} />
            <Filters.StaticFilter name='schedule' value={props.scheduleId} />
          </Fields.AvailableScheduleUsers>
        </Fieldset>

        <SmartviewContentSeparator />

        <div className='form-action'>
          <Button type='submit'><Translation name='actions.create_shift' /></Button>
        </div>

        <Pipeline>
          <TriggerPipelineOnFormSubmit />
          <CallbackOnPipe callback={(payload) => { setActiveShift(payload.data.model.id) }} />
          <MountSmartviewOnPipe
            smartview={<ViewShiftSmartview />}
          />
          <ExecuteOperationOnPipe
            resourceName='shifts.schedule_slot'
            operationName='grouped_by_day'
          />
          <ExecuteOperationOnPipe
            resourceName='shifts.schedule'
            operationName='summary'
            data={payload => {
              return { schedule: payload.data.model.schedule_id }
            }}
          />
        </Pipeline>
      </Model>

    </Smartview>
  )
}

CreateShiftSmartview.defaultProps = {}

CreateShiftSmartview.propTypes = {
  scheduleId: PropTypes.number.isRequired,
  weekDay: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired
}

export default CreateShiftSmartview
